// src/features/employees/StatusUpdateModal.jsx
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Button,
} from "@mui/material";

const StatusUpdateModal = ({
  open,
  onClose,
  employee,
  statusValue,
  reasonValue,
  onStatusChange,
  onReasonChange,
  onUpdateStatus,
  loading = false,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Update Employee Status</DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        {employee && (
          <>
            <TextField
              fullWidth
              select
              label="Status"
              value={statusValue}
              onChange={onStatusChange}
              sx={{ mb: 2 }}
              disabled={loading}
            >
              <MenuItem value="Approved">Approved</MenuItem>
              <MenuItem value="Hold">Hold</MenuItem>
              <MenuItem value="Rejected">Rejected</MenuItem>
            </TextField>
            
            
          </>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        
        <Button 
          variant="contained" 
          onClick={onUpdateStatus}
          disabled={!statusValue || !employee || loading}  
        >
          {loading ? "Updating..." : "Update Status"}  
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StatusUpdateModal;
